import { Component, OnInit } from '@angular/core';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { OrderCreationService } from '../../../../../Services/order-creation.service';
import { FirmSelectionService } from '../../../../../Services/firm-selection.service';

@Component({
  selector: 'app-raw-material-returned-list',
  standalone: true,
  imports: [NgFor, NgIf,DatePipe],
  templateUrl: './raw-material-returned-list.component.html'
})
export class RawMaterialReturnedListComponent implements OnInit {

  returnedOrders: any[] = [];
  selectedFirm!: number;
  loading = false;

  constructor(
    private orderService: OrderCreationService,
    private firmService: FirmSelectionService
  ) {}

  ngOnInit(): void {
    this.firmService.selectedFirmName$.subscribe((firm: any) => {
      this.selectedFirm = firm?.id;
      if (this.selectedFirm) {
        this.loadReturnedOrders();
      }
    });
  }

  loadReturnedOrders() {
    this.loading = true;

    this.orderService.getReturnedRawMaterials(this.selectedFirm).subscribe({
      next: (res: any) => {
        this.returnedOrders = res.data || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
